import script from "./ProductionSectionCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductionSectionCard.vue?vue&type=script&setup=true&lang=js"

import "./ProductionSectionCard.vue?vue&type=style&index=0&id=339d497a&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-339d497a"]])

export default __exports__